export default {"src":"/_next/static/media/logo-korcham.ba716666.svg","height":120,"width":252,"blurWidth":0,"blurHeight":0};